import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.highlightClasses = ["border-b-4", "text-purple"];
    this.links = Array.from(this.element.querySelectorAll('a'));

    // Handle scrolling
    document.addEventListener('scroll', this.onScroll.bind(this));
    this.onScroll(); // Initialize the tabs highlight state, in case the user clicked straight to a particular section.

    // Handle clicks
    for (var i = 0; i < this.links.length; i++) {
      this.links[i].addEventListener('click', this.onClick.bind(this));
    }
  }

  onScroll() {
    var position = window.scrollY;

    for (var i = 0; i < this.links.length; i++) {
      var link = this.links[i];
      var sectionName = link.href.split('#')[1];
      var section = document.getElementById(sectionName);
      var top = window.scrollY + section.getBoundingClientRect().top - this.element.clientHeight;
      var bottom = window.scrollY + section.getBoundingClientRect().bottom - this.element.clientHeight;

      // The first section is unique.  If the top of the window is either inside or above that section, we highlight it.
      // For all other sections, we look for the top of the window to be inside the section.
      if ((i == 0 && position < top) || (position >= top && position < bottom)) {
        this.highlightLink(link);
        return;
      }
    }

    this.unhighlightLinks(this.links);
  }

  highlightLink(link) {
    for (var i = 0; i < this.highlightClasses.length; i++) {
      link.classList.add(this.highlightClasses[i]);
    }

    var otherLinks = this.links.filter((l) => l != link);
    this.unhighlightLinks(otherLinks);
  }

  unhighlightLinks(links) {
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      for (var c = 0; c < this.highlightClasses.length; c++) {
        link.classList.remove(this.highlightClasses[c]);
      }
    }
  }

  onClick(e) {
    e.preventDefault();
    var link = e.target;
    var sectionName = link.href.split('#')[1];
    var section = document.getElementById(sectionName);
    section.scrollIntoView({ behavior: 'smooth' });
  }
}